<template>
  <div>
    <div class="q-radio-container main-color">
      <div>
        <label v-html="question.q"></label>
      </div>
      <div>
        <table class="matrix-table">
          <thead>
            <tr>
              <th></th>
              <th v-for="answer in arrayAns" :key="answer.value">{{ answer.value }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="option in arrayOptions" :key="option.value">
              <td>{{ option.value }}</td>
              <td v-for="answer in arrayAns" :key="answer.id" class="matrix-cell">
                  <input
                  style="opacity: 1; pointer-events: all;"
                    :type="question.radio_button ? 'checkbox' : 'checkbox'"
                    :name="option.value"
                    :id="`${option.value}-${answer.value}`"
                    :value="option.id"
                    :checked="isSelected(option.id, answer.id)"
                    @change="handleSelection(option.id, answer.id)"
                  >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<style>
.matrix-table {
  border-collapse: collapse;
  width: 100%;
}

.matrix-table th,
.matrix-table td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

.matrix-cell {
  border-top: none;
}
</style>

<script>
export default {
  name: "options-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    },
    answerProp:{
      type: String,
      default: ""
    },
    readOnly:{
      type:Boolean,
      default: false
    },
    arrayAnswers: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    isSelected(optionId, answerId) {
      var select =  this.arrayOptions.find(option => option.id === optionId).selectedOptions[answerId];
      console.log(select);
      return select;
    },
    handleSelection(optionId, answerId) {
      const respuesta = this.arrayOptions.find(respuesta => respuesta.id === optionId);
      
      respuesta.selectedOptions[answerId] = !respuesta.selectedOptions[answerId];
      console.log(respuesta);
    },
    emitValueOptions: function() {
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    getArrayAnswers: function() {
      this.arrayAnswers = [];
      for (var i in this.question.answers){
        this.arrayAnswers.push(this.question.answers[i].value);
      }
    },
    checkAnswer: function(){
      if(this.arrayAnswers.includes(this.answer) == false){
        alert('No contiene el texto');
      }

    }
  },
  beforeMount: function() {
    this.arrayOptions = [];
    for (var i in this.question.options){
      //this.arrayOptions.push(this.question.answers[i].value);
      this.arrayOptions.push({
        id: +i,
        label: this.question.options[i],
        value: this.question.options[i],
        selectedOptions: {}
      });
    }
    this.arrayAns = [];
    for (var j in this.question.answers){
      //this.arrayOptions.push(this.question.answers[i].value);
      this.arrayAns.push({
        id: +j,
        label: this.question.answers[j],
        value: this.question.answers[j]
      });
    }
    console.log(this.arrayOptions);
  }
  ,
  data: function() {
    return {
      answerf: this.answerProp
    };
  }
};
</script>

<style lang="scss" scoped>
  .md-radio {
    display: flex;
  }
</style>
